import { shouldReduceMotion } from '@theme/utilities';

const FLOATING_ACTIONS_SCROLL_THRESHOLD = 320;

/**
 * @param {HTMLElement} root
 */
function initFloatingActions(root) {
  const scrollButton = root.querySelector('[data-scroll-to-top]');

  if (scrollButton instanceof HTMLButtonElement) {
    const scrollBehavior = shouldReduceMotion() ? 'auto' : 'smooth';
    const abortController = new AbortController();
    const { signal } = abortController;

    const toggleScrollButton = () => {
      const shouldShow = window.scrollY > FLOATING_ACTIONS_SCROLL_THRESHOLD;
      scrollButton.classList.toggle('is-visible', shouldShow);
      scrollButton.hidden = !shouldShow;
    };

    scrollButton.addEventListener(
      'click',
      () => {
        window.scrollTo({ top: 0, behavior: scrollBehavior });
      },
      { signal }
    );

    window.addEventListener('scroll', toggleScrollButton, {
      passive: true,
      signal,
    });
    toggleScrollButton();
  }
}

for (const root of document.querySelectorAll('[data-floating-actions]')) {
  if (root instanceof HTMLElement) {
    initFloatingActions(root);
  }
}
